import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

/**
 * A single Kalpita product/solution entry in the Solutions mega-menu.
 */
interface SolutionLink {
  /** Product name as shown in the menu. */
  name: string;
  /** One-line positioning descriptor, taken from each product page hero. */
  descriptor: string;
  /** Router path, relative to the app root. */
  route: string;
}

/**
 * A titled group of products inside the Solutions mega-menu.
 */
interface SolutionGroup {
  heading: string;
  items: SolutionLink[];
}

@Component({
  selector: 'app-solutions-navcard',
  imports: [CommonModule, RouterLink],
  standalone: true,
  templateUrl: './solutions-navcard.component.html',
  styleUrl: './solutions-navcard.component.scss'
})
export class SolutionsNavcardComponent {
  @Output() close = new EventEmitter<void>();

  constructor(private router: Router) {}

  /**
   * The nine Kalpita products, grouped for the mega-menu.
   * Left column renders groups[0] and groups[1]; right column renders groups[2] and groups[3].
   */
  groups: SolutionGroup[] = [
    {
      heading: 'Enterprise AI & Data',
      items: [
        {
          name: 'Kalpita Nexa',
          descriptor: 'Agentic enterprise AI, on-premise or sovereign cloud',
          route: '/products/kalpita-nexa'
        },
        {
          name: 'Kalpita Sentinel',
          descriptor: 'Offline AI data firewall that masks PII on-device',
          route: '/products/kalpita-sentinel'
        }
      ]
    },
    {
      heading: 'Hiring & Talent',
      items: [
        {
          name: 'Kalpita AI Interview',
          descriptor: 'AI-conducted interviews with 7-layer fraud detection',
          route: '/products/kalpita-ai-interview'
        },
        {
          name: 'Kalpita Recruit',
          descriptor: 'AI-native ATS for high-volume hiring',
          route: '/products/kalpita-recruit'
        }
      ]
    },
    {
      heading: 'Engineering & DevOps',
      items: [
        {
          name: 'Kalpita CodeGuard',
          descriptor: 'Autonomous DevSecOps that writes the fix, not just the alert',
          route: '/products/kalpita-codeguard'
        },
        {
          name: 'Kalpita PromptOps',
          descriptor: 'Autonomous DevOps for Azure, from prompt to pipeline',
          route: '/products/kalpita-promptops'
        },
        {
          name: 'Kalpita SprintMind',
          descriptor: 'AI capacity planning that warns before a sprint slips',
          route: '/products/kalpita-sprintmind'
        }
      ]
    },
    {
      heading: 'Industry Solutions',
      items: [
        {
          name: 'Kalpita KrishiAI',
          descriptor: 'Offline AI smart-farming assistant in local languages',
          route: '/products/kalpita-krishiai'
        },
        {
          name: 'Kalpita MoodFit',
          descriptor: 'Explainable AI personal styling, scored and reasoned',
          route: '/products/kalpita-moodfit'
        }
      ]
    }
  ];

  closeCard() {
    this.close.emit();
  }

  navigateTo(path: string) {
    this.close.emit();
    this.router.navigate([`/${path}`]);
  }

}
